import {useEffect, useState} from "react";


export default function useEmployeeHook(){
	let [search] = useState(new URLSearchParams(window.location.search));
	const [URLS,SETURLS] =  useState( {
		username : "https://auth.dice.tech/auth/employee/username",
		login : "https://auth.dice.tech/auth/employee/email",
		emailOtp:`https://auth.dice.tech/auth/employee/email.otp`,
		password :`https://auth.dice.tech/auth/employee/password`
	})
	useEffect(()=>{
		let origin = search.get("origin") || 'dice.tech'

		if(origin==="employee.mena-dice.tech"){
			SETURLS({
				username : "https://provider.mena-dice.tech/auth/employee/username",
				login : "https://provider.mena-dice.tech/auth/employee/email",
				emailOtp:`https://provider.mena-dice.tech/auth/employee/email.otp`,
				password :`https://provider.mena-dice.tech/auth/employee/password`
			})
		}
		if(origin==="user-uat.jkyms.com"){
			SETURLS({
				username : "https://provider-uat.jkyms.com/auth/employee/username",
				login : "https://provider-uat.jkyms.com/auth/employee/email",
				emailOtp:`https://provider-uat.jkyms.com/auth/employee/email.otp`,
				password :`https://provider-uat.jkyms.com/auth/employee/password`
			})
		}
		if(origin==="user.jkyms.com"){
			SETURLS({
				username : "https://provider.jkyms.com/auth/employee/username",
				login : "https://provider.jkyms.com/auth/employee/email",
				emailOtp:`https://provider.jkyms.com/auth/employee/email.otp`,
				password :`https://provider.jkyms.com/auth/employee/password`
			})
		}
		if(origin==="stage.adanionect.com" || origin==="stage.adanionect.comuser"){
			SETURLS({
				username : "https://stage.adanionect.com/api/employee/auth/v2/username",
				login : "https://stage.adanionect.com/api/employee/auth/v2/email",
				emailOtp:`https://stage.adanionect.com/api/employee/auth/v2/email.otp`,
				password :`https://stage.adanionect.com/api/employee/auth/v2/password`
			})
		}
		if(origin==="adanionect.com"){
			SETURLS({
				username : "https://www.adanionect.com/api/employee/auth/v2/username",
				login : "https://www.adanionect.com/api/employee/auth/v2/email",
				emailOtp:`https://www.adanionect.com/api/employee/auth/v2/email.otp`,
				password :`https://www.adanionect.com/api/employee/auth/v2/password`

			})
		}
		if(origin==="www.adanionect.com"){
			SETURLS({
				username : "https://www.adanionect.com/api/employee/auth/v2/username",
				login : "https://www.adanionect.com/api/employee/auth/v2/email",
				emailOtp:`https://stage.adanionect.com/api/employee/auth/v2/email.otp`,
				password :`https://www.adanionect.com/api/employee/auth/v2/password`
			})
		}

		if (origin === 'user.yesleap.in') {
			SETURLS({
				username : "https://provider.yesleap.in/auth/employee/username",
				login : "https://provider.yesleap.in/auth/employee/email",
				emailOtp:`https://provider.yesleap.in/auth/employee/email.otp`,
				password :`https://provider.yesleap.in/auth/employee/password`
			})
		}
		if (origin === 'user.yespayleaf.in') {
			SETURLS({
				username : "https://provider.yespayleaf.in/auth/employee/username",
				login : "https://provider.yespayleaf.in/auth/employee/email",
				emailOtp:`https://provider.yespayleaf.in/auth/employee/email.otp`,
				password :`https://provider.yespayleaf.in/auth/employee/password`
			})
		}

		if(origin === 'fedgo.dev.eka.io/user-uat' || origin === 'fedgo.dev.eka.io_user-uat') {
			SETURLS({
				username : "https://fedgo.dev.eka.io/provider-uat/auth/employee/username",
				login : "https://fedgo.dev.eka.io/provider-uat/auth/employee/email",
				emailOtp:`https://fedgo.dev.eka.io/provider-uat/auth/employee/email.otp`,
				password :`https://fedgo.dev.eka.io/provider-uat/auth/employee/password`,
				code: "https://fedgo.dev.eka.io/provider-uat/auth/employee/code"
			})
		}

		if(origin === 'hilapdev.adityabirla.com/user-uat' || origin === 'hilapdev.adityabirla.com/user-uat/' || origin === 'hilapdev.adityabirla.com_user-uat') {
			SETURLS({
				username : "https://hilapdev.adityabirla.com/provider-uat/auth/employee/username",
				login : "https://hilapdev.adityabirla.com/provider-uat/auth/employee/email",
				emailOtp:`https://hilapdev.adityabirla.com/provider-uat/auth/employee/email.otp`,
				password :`https://hilapdev.adityabirla.com/provider-uat/auth/employee/password`,
				code: "https://hilapdev.adityabirla.com/provider-uat/auth/employee/code"
			})
		}

		if(origin === 'hilap.adityabirla.com/user' || origin === 'hilap.adityabirla.com/user/' || origin === 'hilap.adityabirla.com_user') {
			SETURLS({
				username : "https://hilap.adityabirla.com/provider/auth/employee/username",
				login : "https://hilap.adityabirla.com/provider/auth/employee/email",
				emailOtp:`https://hilap.adityabirla.com/provider/auth/employee/email.otp`,
				password :`https://hilap.adityabirla.com/provider/auth/employee/password`,
				code: "https://hilap.adityabirla.com/provider/auth/employee/code"
			})
		}
	},[search])
	return URLS
}
